import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { User } from "../types"
import { API_URL } from "../constants"

export function useUtentiList(params: Record<string, string> = {}) {
  return useList<User>(`${API_URL}/admin/users`, {
    query: params,
  })
}

export function useUtente(id: number | undefined) {
  return useDetail<User>(`${API_URL}/admin/users`, id?.toString())
}

export function useCreateUtente() {
  return useCreate<User>(`${API_URL}/admin/users`)
}

export function useUpdateUtente() {
  return useUpdate<User>(`${API_URL}/admin/users`)
}

export function useDeleteUtente() {
  return useDelete(`${API_URL}/admin/users`)
}

export function usePartialUpdateUtente() {
  return usePartialUpdate<User>(`${API_URL}/admin/users`)
}

export function useDeleteMultiUtente() {
  return useAction(`${API_URL}/admin/users/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}
